import { render } from "./coaches-filter-sidebar.vue?vue&type=template&id=0091f85e"
import script from "./coaches-filter-sidebar.vue?vue&type=script&lang=js"
export * from "./coaches-filter-sidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__